/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-template */
/* eslint-disable arrow-body-style */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-return */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
import React from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

interface FooterProps {
    children?: React.ReactNode;
    height?: string;
}

const Footer = (props: FooterProps) => {
    const { children, height } = props;
    return (
        <AppBar
            component="footer"
            position="fixed"
            elevation={0}
            sx={{
                top: "auto",
                bottom: 0,
                height,
                "& .MuiToolbar-root": {
                    p: 0,
                },
            }}
        >
            <Toolbar sx={{ height }}>{children}</Toolbar>
        </AppBar>
    );
};

export default Footer;
